<template>
    <div
        :data-component-name="$options.name"
        :class="((!field.inputClass) ? 'o-grid-12' : field.inputClass)"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" />
        <div class="o-form__item">
            <input
                class="o-input"
                :class="{ 'readonly': field.inputReadonly === true }"
                :readonly="(field.inputReadonly === true && field.value !== null && field.value != '') ? 'readonly' : false"
                :min="(fieldMinValue && String(fieldMinValue).trim() != '') ? fieldMinValue : null"
                :max="(fieldMaxValue && String(fieldMaxValue).trim() != '') ? fieldMaxValue : null"
                :maxlength="(field.inputMaxlength && String(field.inputMaxlength).trim() != '') ? field.inputMaxlength : null"
                :minlength="(field.inputMinlength && String(field.inputMinlength).trim() != '') ? field.inputMinlength : null"
                v-on="readOnlyHandlers"
                :type="fieldType"
                v-model="field.value"
                :id="'input-'+field.id"
                :name="field.inputName"
                :placeholder="field.inputPlaceholder"
                :required="(field.inputRequired === true) ? 'required' : false"
                :pattern="(field.inputPattern && field.inputPattern !='') ? field.inputPattern : null"
                :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : false"
                @blur="formatValue(this.field.value)"
            >
            <div class="o-form__validation">
                <span class="o-form__validation__required">
                    {{ _t('Ce champ est obligatoire.') }}
                </span>
                <span class="o-form__validation__error" v-if="field.inputPatternInvalidMessage && String(field.inputPatternInvalidMessage).trim()!=''" v-html="field.inputPatternInvalidMessage">
                </span>
                <span class="o-form__validation__error" v-else-if="fieldMaxValue !== null && parseFloat(field.value) > parseFloat(fieldMaxValue)">
                    {{ _t('La valeur entrée doit être inférieure ou égale à') }} {{ fieldMaxValue }}.
                </span>
                <span class="o-form__validation__error" v-else-if="fieldMinValue !== null && parseFloat(field.value) < parseFloat(fieldMinValue)">
                    {{ _t('La valeur entrée doit être supérieure ou égale à') }} {{ fieldMinValue }}.
                </span>
                <span class="o-form__validation__error" v-else>
                    {{ _t('Ce champ est invalide.') }}
                </span>
            </div>

        </div>
        <span class="o-form__instruction" v-if="field.inputInstructions && String(field.inputInstructions).trim() != ''">
            <small v-html="field.inputInstructions"></small>
        </span>
    </div>
</template>
<script>
    export default {
        name: 'Input-text',
        props: {
            field: {
                type: Object,
                default() {
                    return {}
                },
            },
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data(){
            return {
                readOnlyHandlers: {
                    keydown: this.handleEvent,
                    paste: this.handleEvent,
                    focus: this.handleEvent,
                    mousedown: this.handleEvent,
                }
        	}
        },
        mounted() {
            if(this.field.inputType === 'hidden') {
                this.field.inputClass = 'o-hidden-field-group';
            }
        },
        computed: {
            fieldType() {
                switch (this.field.inputType) {
                    case 'phone':
                        type = 'text';
                        break;

                    // case 'hidden':
                    //     type = 'text';
                    //     break;

                    default:
                        type = this.field.inputType;
                        break;
                }

                return type;
            },

            fieldMaxValue() {
                let value = null

                if (this.field.inputType == 'date' || this.field.inputType == 'month') {
                    if (this.field.inputDateMax && this.field.inputDateMax !== null && String(this.field.inputDateMax).trim() != '' && parseInt(this.field.inputDateMax) == this.field.inputDateMax) {
                        value = new Date(this.field.inputDateMax)
                    } else if (this.field.inputDateMax && String(this.field.inputDateMax).trim() != '') {
                        let suffix = this.field.inputDateMax.slice(-1)
                        switch (suffix) {
                            case 'd':
                                value = new Date(new Date().setDate(new Date().getDate() + parseInt(this.field.inputDateMax.slice(0, -1))))
                                break;

                            case 'w':
                                value = new Date(new Date().setDate(new Date().getDate() + (parseInt(this.field.inputDateMax.slice(0, -1)) * 7)))
                                break;

                            case 'm':
                                value = new Date(new Date().setMonth(new Date().getMonth() + parseInt(this.field.inputDateMax.slice(0, -1))))
                                break;

                            case 'y':
                                value = new Date(new Date().setFullYear(new Date().getFullYear() + parseInt(this.field.inputDateMax.slice(0, -1))))
                                break;

                            default:
                                value = this.field.inputDateMax
                                break;
                        }

                    }
                    if (value) {
                        value = value.toISOString().split('T')[0]
                        if (this.field.inputType == 'month') value = value.slice(0, 7)
                    }
                }

                if (this.field.inputType == 'number') {
                    if (this.field.inputNumberMax && this.field.inputNumberMax !== null && String(this.field.inputNumberMax).trim() != '') {
                        if (String(this.field.inputNumberMax).trim() != '' && String(this.field.inputNumberMax).startsWith('javascript:')) {
                            try {
                                value = eval(this.field.inputNumberMax.replace('javascript:', ''))
                            } catch (e) {
                                console.error(e)
                                value = null
                            }
                        } else {
                            value = parseFloat(this.field.inputNumberMax)
                        }
                    }
                }


                return value;
            },
            fieldMinValue() {
                let value = null

                if (this.field.inputType == 'date' || this.field.inputType == 'month') {
                    if (this.field.inputDateMin && this.field.inputDateMin !== null && String(this.field.inputDateMin).trim() != '' && parseInt(this.field.inputDateMin) == this.field.inputDateMin) {
                        value = new Date(this.field.inputDateMin)
                    } else if (this.field.inputDateMin && String(this.field.inputDateMin).trim() != '') {
                        let suffix = this.field.inputDateMin.slice(-1)
                        switch (suffix) {
                            case 'd':
                                value = new Date(new Date().setDate(new Date().getDate() + parseInt(this.field.inputDateMin.slice(0, -1))))
                                break;

                            case 'w':
                                value = new Date(new Date().setDate(new Date().getDate() + (parseInt(this.field.inputDateMin.slice(0, -1)) * 7)))
                                break;

                            case 'm':
                                value = new Date(new Date().setMonth(new Date().getMonth() + parseInt(this.field.inputDateMin.slice(0, -1))))
                                break;

                            case 'y':
                                value = new Date(new Date().setFullYear(new Date().getFullYear() + parseInt(this.field.inputDateMin.slice(0, -1))))
                                break;

                            default:
                                value = this.field.inputDateMin
                                break;
                        }
                    }
                    if (value) {
                        value = value.toISOString().split('T')[0]
                        if (this.field.inputType == 'month') value = value.slice(0, 7)
                    }
                }


                if (this.field.inputType == 'number') {
                    if (this.field.inputNumberMin && this.field.inputNumberMin !== null && String(this.field.inputNumberMin).trim() != '') {
                        if (String(this.field.inputNumberMin).trim() != '' && String(this.field.inputNumberMin).startsWith('javascript:')) {
                            try {
                                value = eval(this.field.inputNumberMin.replace('javascript:', ''))
                            } catch (e) {
                                console.error(e)
                                value = null
                            }
                        } else {
                            value = parseFloat(this.field.inputNumberMin)
                        }
                    }
                }


                return value;
            },
        },
        methods: {
            handleEvent(e) {
                if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
            },
            formatValue(value) {
                if (this.field.inputType == 'phone') {
                    value = value.replace(/[^0-9]/g, '');
                    if (value.length == 10) {
                        value = value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                    }
                    if (value.length == 11) {
                        value = value.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4');
                    }
                    this.field.value = value;
                }
            },
        },
    }
</script>